<div mat-dialog-title>
  <div class="d-md-none my-3">
    <div class="d-flex justify-content-center">
      <div style="width: 79px;height: 5px; border-radius: 41px; background-color: #D9D9D9"></div>
    </div>
  </div>
  <div class="d-flex align-items-center">
    <img src="assets/imgs/icones/info-azul.svg" class="me-3">
    <span class="modal-title">Motivo cancelamento:</span>
  </div>
</div>

<div mat-dialog-content >
  <p *ngIf="observacao">{{observacao}}</p>
  <p *ngIf="!observacao">Sem descrição</p>
  <div class="d-flex justify-content-center align-content-center">
    <button class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()"> Voltar </button>
  </div>
</div>

